/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AldreteScore from './aldrete-score';
import AldreteScoreDetail from './aldrete-score-detail';
import AldreteScoreUpdate from './aldrete-score-update';
import AldreteScoreDeleteDialog from './aldrete-score-delete-dialog';

const AldreteScoreRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AldreteScore />} />
    <Route path="new" element={<AldreteScoreUpdate />} />
    <Route path=":id">
      <Route index element={<AldreteScoreDetail />} />
      <Route path="edit" element={<AldreteScoreUpdate />} />
      <Route path="delete" element={<AldreteScoreDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AldreteScoreRoutes;
